var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.73333C11.4286 1.73333 14.0405 3.57933 15.3155 6.5C14.0405 9.42067 11.4286 11.2667 8.5 11.2667C5.57136 11.2667 2.95955 9.42067 1.68455 6.5C2.95955 3.57933 5.57136 1.73333 8.5 1.73333ZM8.5 0C4.63636 0 1.33682 2.69533 0 6.5C1.33682 10.3047 4.63636 13 8.5 13C12.3636 13 15.6632 10.3047 17 6.5C15.6632 2.69533 12.3636 0 8.5 0ZM8.5 4.33333C9.56636 4.33333 10.4318 5.304 10.4318 6.5C10.4318 7.696 9.56636 8.66667 8.5 8.66667C7.43364 8.66667 6.56818 7.696 6.56818 6.5C6.56818 5.304 7.43364 4.33333 8.5 4.33333ZM8.5 2.6C6.58364 2.6 5.02273 4.35067 5.02273 6.5C5.02273 8.64933 6.58364 10.4 8.5 10.4C10.4164 10.4 11.9773 8.64933 11.9773 6.5C11.9773 4.35067 10.4164 2.6 8.5 2.6Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.2536f385999a62bafb753f2676fc9e88.svg";
export { ForwardRef as ReactComponent };